<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-mindset">
                <b-row>
                    <b-col cols="12" lg="6">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="sun"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_MINDSET') }}
                                </h5>
                            </b-card-header>
                            <b-card-body class="light-bg">
                                <template v-if="$utils.themeIs('wellcoaches')">
                                    <b-row>
                                        <report-widget widget-key="WBI_SCORE"/>
                                    </b-row>

                                    <b-row class="mt-3">
                                        <report-widget widget-key="RATIO_SCORE">
                                            <div class="ratio-value">
                                                {{ ratioScore }}
                                            </div>
                                        </report-widget>
                                    </b-row>
                                </template>
                                <div class="report-widget" :class="$utils.themeIs('wellcoaches') ? 'mt-3' : ''">
                                    <b-card no-body
                                            @click.stop="showRtcModal()">
                                        <b-card-body class="report-widget__body__meter">
                                            <div class="report-widget__title">
                                                {{ $i18n.gt('HEADING_RTC_GAUGE') }}
                                            </div>
                                        </b-card-body>
                                    </b-card>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
        <b-modal :id="modalId" :title="$i18n.gt('HEADING_RTC_GAUGE')" size="lg" hide-footer>
            <report-rtc-table :widget-keys="widgetKeys"/>
        </b-modal>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'
import NotesToSelf from "../components/NotesToSelf";

/**
 * Page to manage a Participant's wellness mindset
 */
export default Vue.extend({
    name: 'MyMindset',
    mixins: [PatientPageMixin],
    data () {
        return {
            widgetKeys:
                [["RTC_WELLBEING_SCORE", "RTC_ENERGY_SCORE", "RTC_STRESS_SCORE", "RTC_PRODUCTIVITY_SCORE", "RTC_SATISFACTION_SCORE", "RTC_WORK_LIFE_SCORE"],
                    ["RTC_PHYS_ACTIVITY_SCORE", "RTC_EATING_HABITS_SCORE", "RTC_WEIGHT_CONTROL_SCORE", "RTC_SLEEP_SCORE", "RTC_MANAGE_MEDICAL_SCORE", "RTC_REDUCE_NEED_MEDS_SCORE"],
                    ["RTC_NICOTINE_SCORE", "RTC_ALCOHOL_SCORE", "RTC_DRUG_USE_SCORE"]]
        }
    },
    computed: {
        ratioScore() {
            const scoreDefs = this.$store.state.patientParticipant.latestScoreDefs
            if (scoreDefs) {
                const scoreDef = scoreDefs['RATIO_SCORE']
                if (scoreDef && scoreDef.score.score) { // between 0 and 1
                    return Number.parseFloat(scoreDef.score.score).toPrecision(2) + ' : 1'
                }
            }
            return null
        },
        modalId() {
            return `modal_rtc`
        },
    },
    methods : {
        showRtcModal() {
            this.$bvModal.show(this.modalId)
        }
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.report-widget {
    cursor: pointer;

    .card {
        background: #fff;
        transition: all .3s;
        margin-bottom: 0;
        @media(min-width: 540px) {
            height: 100%;
        }

        &:hover {
            box-shadow: 0 0 10px rgba(0, 0, 0, .15);

            .report-widget__timestamp {
                color: var(blue);
            }
        }
    }

    @media(max-width: 719px) {
        margin-bottom: 1rem;
    }

    // see also PatientCoachingSummaryMindset
    .ratio-value {
        width: 100%;
        text-align: center;
        font-size: 1.5em;
    }
}

</style>
